<template>
  <div class="custom-invoice" v-for="(table, idx) of tables" :key="idx">
    <InvoiceTable :idx="idx" :table="table" />
  </div>
</template>
<script>
import { mapState } from 'pinia'
import { invoiceStore } from '@/stores/invoice'
import InvoiceTable from '@/components/invoice/forms/InvoiceTable.vue'
export default {
  name: 'InvoiceTables',
  components: {
    InvoiceTable
  },
  computed: {
    ...mapState(invoiceStore, ['loading', 'invoiceTables']),
    isLoading() {
      let _is = false
      if (this.loading) {
        if (this.loading.analysis || this.loading.invoice) {
          _is = true
        }
      }
      return _is
    },
    tables() {
      let _tables = []
      if (this.invoiceTables) {
        _tables = this.invoiceTables
      }
      return _tables
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-invoice {
  table {
    width: 100%;
    height: auto;
    border-collapse: collapse;
    th,
    td {
      border: 1px solid #000;
      padding: 5px;
    }
    th {
      background-color: #f0f0f0;
    }
  }
}
</style>
